/**
 * @param element object
 * @param body object
 */
export default function closeAllHints(element, body, HintService, scope) {
	body.find('.hints-overlay').remove();
	body.find('.hints-close').remove();
	element.removeClass('show-hint-for-item');
	body.find('.hint-tooltip').remove();
	HintService.setAllShown();
	scope.showableElements = [];
}
